import api from '../api/axios';

const getOptions = (proposalId) => {
  return api.get(`proposal/${proposalId}/options`);
};

const createOption = (proposalId) => {
  return api.post(`proposal/${proposalId}/options`);
};

const deleteOption = (proposalId, optionId) => {
  return api.delete(`proposal/${proposalId}/options/${optionId}`);
};

const acceptOption = (proposalId, optionId) => {
  return api.post(`proposal/${proposalId}/options/${optionId}/accept`);
};

const proposalOptionServices = {
  getOptions,
  createOption,
  deleteOption,
  acceptOption,
};

export default proposalOptionServices;
